<script>
export default {
    name: 'HeaderBreadcrumbs',
};
</script>

<script setup>
import { computed } from 'vue';
import usePageBreadcrumbs, { getBreadcrumbAttrs, getBreadcrumbLabel } from '@/composables/usePageBreadcrumbs';

const { breadcrumbs } = usePageBreadcrumbs();

const displayedBreadcrumbs = computed(() => breadcrumbs.value
    .map(breadcrumb => ({
        ...breadcrumb,
        label: getBreadcrumbLabel(breadcrumb),
        attrs: getBreadcrumbAttrs(breadcrumb),
    }))
    .filter(({ label, component, attrs }) => !!label || (!!component && attrs !== null)));
</script>

<template>
    <base-breadcrumbs
        class="font-semibold text-white"
        :divider="{ name: 'chevron-right', prefix: 'fas', class: 'w-4 h-4' }"
        :items="displayedBreadcrumbs"
    >
        <base-breadcrumbs-item
            v-for="breadcrumb in displayedBreadcrumbs"
            :key="breadcrumb.key"
            :label="getBreadcrumbLabel(breadcrumb)"
        >
            <component
                v-if="breadcrumb.component"
                :is="breadcrumb.component"
                v-bind="breadcrumb.attrs"
            />
        </base-breadcrumbs-item>
    </base-breadcrumbs>
</template>
